import React from 'react';
import { Table } from 'antd';
import type { TableProps } from 'antd';
import CardList, { CardLayout } from './CardList';
import { useCompactLayout } from '../../hooks/useCompactLayout';

/**
 * A plain antd Table on laptops; the same rows as cards on phones and small tablets (below 992 px).
 * `card` says which columns head the card and which sit at its foot (see CardList).
 */
function ResponsiveTable<T extends object = any>(props: TableProps<T> & { card?: CardLayout }) {
  const compact = useCompactLayout();
  const { card, ...rest } = props;
  if (compact) return <CardList<T> {...(rest as any)} columns={(rest.columns || []) as any[]} layout={card} />;
  return <Table<T> {...rest} />;
}

export default ResponsiveTable;
